import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { defaultLocale, locale, messages } from '@/i18n/index';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  messages,
  locale,
  fallbackLocale: defaultLocale,
});

